/* eslint-disable no-useless-escape */

export default {
  LINKEDIN_URL: /^(https?:\/\/)?([w]{3}\.)?linkedin.com\/in\/([\w|-]+).*$/i,
  SPOTIFY_URL: /^(https?:\/\/)?open\.spotify\.com\/user\/([\w|-]+).*$/i,
  YOUTUBE_URL: /^(https?:\/\/)?([w]{3}\.)?youtube.com\/user\/([\w|-]+).*$|^$/i,
  PHONE_NUMBER: /^(\d|#|\*|\+|\.|\s){8,}$/
}
